import React, { useRef,useState } from 'react';
import './index.less';
import { Link } from "react-router-dom";
import logo1 from '@/assets/bottom/address.png';

const  BottomPage =()=> {



    const NavClick = (path,event)=>{
      console.log(path)
      if(!path){
        event.preventDefault()
      }
    }

    return (  
      <div className='bottom_page'>
        <div className="middle">
          <div className="message">
                <div className="left_word">
                      <div className="cube">
                          <div className="bottom_bar">
                              {/* <div className='line address'>
                                <div className="icon"><img src={logo1} alt="" /></div>
                                <p><span>公司地址:</span>拓普電子科技有限公司                               </p>
                              </div> */}
                              <div className="tagline">
                                 專業的<span>智算產品</span>與解決方案<span>提供商</span>
                              </div>
                          </div>
                      </div>

                </div>
                <div className="right_line"></div>
          </div>
          <div className="jump">
             <div className="name">版權所有</div>
             {/* <p className='call'>拓普電子科技有限公司. All rights reserved.</p> */}
             {/* <a rel="stylesheet" href="http://beian.miit.gov.cn/" target="_blank" className="cut">粵ICP備粵ICP備16103764號-1</a>   */}
             <a rel="stylesheet" href="http://beian.miit.gov.cn/" target="_blank">©2026 拓普電子有限公司版權所有</a>       
          </div>

        </div>

      </div>  
    );  
}
  
export default  BottomPage;